import config from "../config";
import commonRoutes from './commonRoutes';

let { createSaleClientRoot } = config;

export default {
    RE_WARRANTY_TRANSACTION_QUESTION: createSaleClientRoot + "/warranty-transaction",
    RE_PROPERTY_ADDRESS: createSaleClientRoot + "/property-address",
    RE_AGENT_DETAILS: createSaleClientRoot + "/agent-details",
    RE_BUYER_DETAILS: createSaleClientRoot + "/buyer-details",
    RE_REPRESENTING: createSaleClientRoot + "/representing",
    RE_CLOSING_DATE: createSaleClientRoot + "/closing-date",
    RE_WHO_IS_PAYING: createSaleClientRoot + "/who-is-paying",
    RE_PAYMENT_TIME: createSaleClientRoot + "/payment-time",
    RE_TITLE_COMPANY_DETAILS: createSaleClientRoot + "/title-company-details",
    RE_ORDER_CONFIRMATION: createSaleClientRoot + "/order-confirmation",
    RE_ADDONS: createSaleClientRoot + '/plan-addons',
    ...commonRoutes
}